export default {
    fullHeight: {
        height: "100%"
    },
    chipStyles: {
        background: "none"
    },
    buttonStyles: {
        border: "none",
        justifyContent: "left",
        textTransform: "capitalize",
        ":hover": {
            border: "none"
        }
    }
};
